'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');

(function (TableDataTypes) {
  TableDataTypes["STRING"] = "string";
  TableDataTypes["NUMBER"] = "number";
  TableDataTypes["DATE"] = "date";
  TableDataTypes["BOOLEAN"] = "boolean";
})(exports.TableDataTypes || (exports.TableDataTypes = {}));

(function (Alignments) {
  Alignments["LEFT"] = "left";
  Alignments["CENTER"] = "center";
  Alignments["RIGHT"] = "right";
})(exports.Alignments || (exports.Alignments = {}));

(function (CellTypes) {
  CellTypes["SUPER_HEADER"] = "super-header";
  CellTypes["HEADER"] = "header";
  CellTypes["BODY"] = "body";
  CellTypes["FOOTER"] = "footer";
})(exports.CellTypes || (exports.CellTypes = {}));
